import Marquee from "react-fast-marquee";
import Bahrain from "../../../../assets/images/nationalFlag/bahrain.svg";
import Brunai from "../../../../assets/images/nationalFlag/Brunei.svg";
import Cambodia from "../../../../assets/images/nationalFlag/Cambodia.svg";
import Canada from "../../../../assets/images/nationalFlag/Canada.svg";
import HongKong from "../../../../assets/images/nationalFlag/Hong Kong.svg";
import Italy from "../../../../assets/images/nationalFlag/Italy.svg";
import Japan from "../../../../assets/images/nationalFlag/japan.svg";
import Jordan from "../../../../assets/images/nationalFlag/Jordan.svg";
import Kuwait from "../../../../assets/images/nationalFlag/Kuwait.svg";
import Lebanon from "../../../../assets/images/nationalFlag/Lebanon.svg";
import Libia from "../../../../assets/images/nationalFlag/libia.svg";
import Malaysia from "../../../../assets/images/nationalFlag/malaysia.svg";
import Maldives from "../../../../assets/images/nationalFlag/Maldives.svg";
import Oman from "../../../../assets/images/nationalFlag/Oman.svg";
import Qatar from "../../../../assets/images/nationalFlag/qatar.svg";
import Saudi from "../../../../assets/images/nationalFlag/Saudi Arabia.svg";
import Singapore from "../../../../assets/images/nationalFlag/Singapore.svg";
import SouthKorea from "../../../../assets/images/nationalFlag/South Korea.svg";
import UAE from "../../../../assets/images/nationalFlag/United Arab Emirates (UAE).svg";
import UK from "../../../../assets/images/nationalFlag/United Kingdom (UK).svg";

export default function Countries() {
  const countries = [
    { name: "সৌদি আরব", flag: Saudi },
    { name: "কাতার", flag: Qatar },
    { name: "সিঙ্গাপুর", flag: Singapore },
    { name: "মালশিয়া", flag: Malaysia },
    { name: "কুয়েত", flag: Kuwait },
    { name: "সংযুক্ত আরব আমিরাত", flag: UAE },
    { name: "জর্ডান", flag: Jordan },
    { name: "মালদ্বীপ", flag: Maldives },
    { name: "ওমান", flag: Oman },
    { name: "ইতালি", flag: Italy },
    { name: "দক্ষিণ কোরিয়া", flag: SouthKorea },
    { name: "লেবানন", flag: Lebanon },
    { name: "যুক্তরাজ্য", flag: UK },
    { name: "ক্যাম্বোডিয়া", flag: Cambodia },
    { name: "হংকং", flag: HongKong },
    { name: "জাপান", flag: Japan },
    { name: "ব্রুনাই", flag: Brunai },
    { name: "বাহারাইন", flag: Bahrain },
    { name: "লিবিয়া", flag: Libia },
    { name: "কানাডা", flag: Canada },
  ];

  return (
    <section className="bg-gradient-to-l from-theme-gray-25 to-theme-gray-25 py-10 overflow-hidden">
      <Marquee pauseOnHover gradient={false} speed={50} autoFill>
        {countries.map((country) => (
          <div
            key={country.name}
            className="flex flex-col items-center justify-center mr-16 shrink-0"
          >
            <img
              src={country.flag}
              alt={country.name}
              className="w-full h-20 object-contain mb-2"
            />
            <span className="text-black text-sm font-medium whitespace-nowrap">
              {country.name}
            </span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
